import { useState, useEffect } from 'react';
import { message } from 'antd';
import { getCpQrList } from '@/services/ant-design-pro/cp';

enum QrStatus {
    AVAILABLE = 'available',
    IN_USE = 'in_use',
    DISABLED = 'disabled',
    LIMIT_REACHED = 'limit_reached',
}

interface QrItem {
    id: bigint | string;
    name?: string | null;
    payment_method: string;
    receiver_name?: string | null;
}

interface UseQrListReturn {
    qrList: QrItem[];
    qrLoading: boolean;
    refreshQrList: () => Promise<void>;
}

export const useQrList = (): UseQrListReturn => {
    const [qrList, setQrList] = useState<QrItem[]>([]);
    const [qrLoading, setQrLoading] = useState(false);

    // 获取可用的二维码列表
    const fetchQrList = async () => {
        try {
            setQrLoading(true);
            const response = await getCpQrList({
                page: 1,
                limit: 100,
                is_active: true,
                status: QrStatus.AVAILABLE,
            });

            if (response.code === 0 && response.data?.data) {
                setQrList(response.data.data);
            }
        } catch (error) {
            console.error('获取二维码列表失败:', error);
            message.error('获取二维码列表失败');
        } finally {
            setQrLoading(false);
        }
    };

    // 初始化时获取二维码列表
    useEffect(() => {
        console.log('fetchQrList');
        fetchQrList();
    }, []);

    return {
        qrList,
        qrLoading,
        refreshQrList: fetchQrList,
    };
};

export type { QrItem };
export { QrStatus }; 